import React from 'react';
import PropTypes from 'prop-types';
import { ApolloProvider } from '@apollo/client';
import authorizedApolloClient from '../apollo/AuthorizedApolloClient';

const AuthorizedApolloClientProvider = (props) => {
    const { children } = props;

    return authorizedApolloClient ? <ApolloProvider client={authorizedApolloClient}>{children}</ApolloProvider> : null;
}

AuthorizedApolloClientProvider.propTypes = {
    children: PropTypes.element.isRequired
}

export default AuthorizedApolloClientProvider;
